import { useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import {
  Datagrid,
  Filter,
  ListProps,
  Pagination,
  sanitizeFetchType,
  TextField,
  TextInput,
  useQuery,
} from 'react-admin'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import List from '../../../common/customized-ra-components/List'
import FilteredReferenceInput from '../../../common/FilteredReferenceInput'
import FilterProps from '../../../common/FilterProps'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import {
  CheckIfAnyModuleHasError,
  CheckLastRefreshError,
} from '../../common/modules/ModuleStatus'
import { DeviceTypes } from '../../../../core/enum/DeviceTypes'
import { useColorPalette } from '../../../../core/devices/devices.utils'
import { DeviceStatusCheck } from '../../../../core/enum/DeviceStatusCheck'

const IksorisParkingTicketCashlessMachineFilters = (props: FilterProps) => {
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const hasAuthority = useHasAuthority()

  return (
    <Filter {...props}>
      <TextInput source="name" alwaysOn autoFocus />
      {hasAuthority(Authority.VIEW_DEVICE_CATEGORIES) && (
        <FilteredReferenceInput
          label="resources.terminals.fields.categoryId"
          source="categoryIdWithDescendants"
          reference={ResourceName.DEVICE_CATEGORIES}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={smallScreen ? 5 : 15}
          filterSource="name"
          selectWithPaginationInputProps={{
            optionText: 'hierarchyString',
            showFilter: true,
          }}
        />
      )}
    </Filter>
  )
}

export const IksorisParkingTicketCashlessMachineList = ({
  ...props
}: ListProps) => {
  const theme = useTheme()
  const colorPalette = useColorPalette(theme)

  const { data: serverDate } = useQuery({
    type: sanitizeFetchType('getServerDateTime'),
    resource: ResourceName.CURRENT_USER,
    payload: {},
  })

  const postRowStyle = (record: any) => {
    if (!serverDate) return {}

    const passageError = CheckLastRefreshError(
      record?.lastRefresh,
      serverDate?.serverDateTime,
    )
    if (passageError) return colorPalette(DeviceStatusCheck.ERROR)

    const passageWarning = CheckIfAnyModuleHasError(
      record.jsonStatus,
      DeviceTypes.IKSORIS_PARKING_TICKET_CASHLESS_MACHINE,
      serverDate?.serverDateTime,
    )
    if (passageWarning) return colorPalette(DeviceStatusCheck.WARNING)
    return colorPalette(DeviceStatusCheck.SUCCESS)
  }

  return (
    <List
      {...props}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      exporter={false}
      filters={<IksorisParkingTicketCashlessMachineFilters />}
      bulkActionButtons={false}
    >
      <Datagrid
        rowStyle={postRowStyle}
        size="small"
        rowClick={(id) =>
          `${ResourceName.IKSORIS_PARKING_TICKET_CASHLESS_MACHINES}/${id}/show`
        }
      >
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <TextField source="address" />
      </Datagrid>
    </List>
  )
}
